import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectModal',
    props: {
        value: { type: Boolean },
        title: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const show = ref(props.value);
        watch(props, () => {
            show.value = props.value;
        });
        watch(show, () => {
            emit("input", show.value);
        });
        return { __sfc: true, props, show, emit };
    }
});
